import { ReactNode } from "react";
import { toast } from "react-toastify";
import { CheckCircleIcon, InfoCircleIcon, WarningIcon } from "@talladega/icons";

type ToastType = "success" | "warning" | "info";

type Props = {
  type?: ToastType;
  title: string;
  message: string;
};

const icon: Record<ToastType, ReactNode> = {
  success: (
    <div className="flex flex-shrink-0 items-center justify-center rounded-full bg-success-primary p-1.5 sm:mx-0">
      <CheckCircleIcon className="h-5 w-5 text-success-400" />
    </div>
  ),
  warning: (
    <div className="mx-0 flex flex-shrink-0 items-center justify-center rounded-full bg-error-primary p-1.5">
      <WarningIcon className="h-6 w-6 text-error-primary" />
    </div>
  ),
  info: (
    <div className="flex flex-shrink-0 items-center justify-center rounded-full bg-secondary-100 p-1.5 sm:mx-0">
      <InfoCircleIcon className="h-6 w-6 text-primary-500" />
    </div>
  ),
};

export const Toast = ({ type = "info", title, message }: Props) => {
  return (
    <div className="flex items-start">
      <div className="flex-shrink-0">{icon[type]}</div>
      <div className="ml-3 w-0 flex-1">
        <p className="text-md font-semibold text-primary">{title}</p>
        <p className="text-sm font-normal text-secondary">{message}</p>
      </div>
    </div>
  );
};

export const toastPop = (type: ToastType, title: string, message: string) => {
  toast.info(<Toast type={type} title={title} message={message} />);
};
